module.exports = __webpack_public_path__ + "images/accents/accent-product-suite@1x-b9aee013e3605b4d6bf261bcc9158351.webp";